export default __webpack_public_path__ + "static/media/team90.51652d73.JPG";